import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import _ from "lodash";
import {
	changeCurrentPath,
	setMappingStatus,
	setMappingInfo, resetMappingStatus,
} from '../../../actions';

import TextField from '@material-ui/core/TextField';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';
import MainButtons from '../../../common/components/main-buttons';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';


import Stepper from '../components/stepper';
import InnerForm from './components/inner-form';


const styles = theme => ({
	listTitle :{

	},
	root: {
		flexGrow: 1,
	},
	cautionText:{
		marginBottom:30,
		padding:10,
		borderTop:'rgba(0,0,0,0.05) solid 5px',
		borderBottom:'rgba(0,0,0,0.05) solid 5px',
		fontSize : '85%'
	},
	cautionAddText:{
		color:"#FF0000"
	},
	paper:{
		maxHeight:'calc(100vh - 455px)',
		overflowY:'scroll'
	},
	templateName:{
		marginBottom: 20
	}
});

class MappingStep4 extends Component {

	constructor(props) {
		super(props);
		const processDivide = !("divide" in props.match.params) || !props.match.params.divide ? "1" : props.match.params.divide;
		this.state = {
			targetDataSource:props.settings.target,
			templateName : props.settings.templateName,
			processDivide
		}
	}

	/** override methods **/
	UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
		if(nextProps.settings.isProcessComplete){
			this.props.dispatch(resetMappingStatus());
			this.props.history.push('/mapping/step1/'+this.state.processDivide);
		}
	}

	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}



	/** event handlers **/
	handleClickBack = ()=>{
		const {history, dispatch} = this.props;

		dispatch(setMappingStatus({
			target:this.state.targetDataSource
		}));
		history.push('/mapping/step3/'+this.state.processDivide);
	};

	handleClickSave = ()=>{
		const {dispatch,settings, auth} = this.props;
		const {target, source, templateID} = settings;

		dispatch(setMappingInfo({
			SessionID : auth.SessionID,
			sourceColumn : source,
			mappingState : _.filter(target,{checked:true}),
			templateName : this.state.templateName,
			templateID : templateID,
			processDivide:this.state.processDivide
		}));

	};

	handleChangeTemplateName = (event) =>{
		this.setState({
			templateName : event.target.value
		});
	};

	handleClickBackList = () =>{
		if(this.state.processDivide === "1"){
			this.props.history.push('/main-list');
		}
		else{
			this.props.history.push('/shipment');
		}
	};

	handleClickBackUpload = () =>{
		this.props.history.push('/upload/'+this.state.processDivide);
	};



	render() {
		const {classes,settings,history} = this.props;
		const {isFetching, isProcessError} = settings;
		const {processDivide} = this.state;

		const disabled = this.state.templateName === '';

		const mainButtons = [
			{type:'SAVE',func:this.handleClickSave, disabled:disabled},
			{type:'BACK',func:this.handleClickBack,text:"戻る"}
		];

		const navigations = [
			{name:processDivide === "2" ? '車番登録' : '一覧',clickFunc:this.handleClickBackList},
			{name:(processDivide === "2" ? '車番情報' : '') + 'CSVアップロード',clickFunc:this.handleClickBackUpload}
		];


		const isTemplateNameError = (this.state.templateName === "");
		const errorHelperText = isTemplateNameError ?  "テンプレート名を入力してください" : null;

		return (
			<div id="main_container">
				{(isFetching) &&
				<Progress/>
				}
				<SpNav history={history}/>
				<Header history={history} navigations={navigations} />
				<article>
					<section className="title_area">
						<h2>テンプレートマッピング</h2>
					</section>
					<section className="with_button">
						<TextField
							label="テンプレート名"
							placeholder="テンプレート名を入力してください"
							className={classes.templateName}
							value={this.state.templateName}
							fullWidth
							variant="outlined"
							onChange={this.handleChangeTemplateName}
							error={isTemplateNameError}
							helperText={errorHelperText}
						/>
						<Stepper activeStep={3}/>
						<p className={classes.cautionText}>
							設定内容を確認してください<br />
							よろしければ「保存」ボタンで保存を実行します
						</p>
					</section>
					<section className="with_button">
						{this.state.targetDataSource.map((row,index)=>{
							if(row.checked){
								return(
									<InnerForm
										key={index}
										row={row}
									/>
								)
							}
							else{
								return null
							}
						})}
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<ErrorDialog
					open={isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.mappingSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MappingStep4);



// WEBPACK FOOTER //
// ./src/routes/mapping/step4/index.js